export const PAGE_HEADER_NAME = "PAGE_HEADER_NAME";
